// for modal redirect

import { useState } from "react";
import axios from "axios";
import Config from "../Config";
import { toast } from "react-toastify";
import { load } from "@cashfreepayments/cashfree-js";
import { useMutation } from "react-query";

export const useCashfreePayment = (token, userEmail, selectedPaymentOption, charges, gstAmount, selectedDues, selectedDuesTotal, totalDuesAmount, tenantdata) => {
    const [isCashfreeInitializing, setIsCashfreeInitializing] = useState(false);

    const processCashFreeOrderStatusTransaction = async (values) => {
        return await axios.post(`${Config.ApiUrl}/cashfree/orderstatus`, values, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const handleOrderTransactionSuccess = (data) => {
        if (data?.data?.data?.order_status === "PAID") {
            window.location.href = "/payment-success";
        } else {
            window.location.href = "/payment-failed";
        }
    };

    const { mutate: orderStatusTransactionMutate } = useMutation(processCashFreeOrderStatusTransaction, {
        onSuccess: handleOrderTransactionSuccess,
        onError: () => {
            window.location.href = `/payment-failed`;
        },
    });

    const handleCashfreePayment = async (payload) => {
        setIsCashfreeInitializing(true);

        try {
            const tenantData = tenantdata; // Fix variable name
            const customerId = tenantData?.propGId && tenantData?.tenantId
                ? `${tenantData.propGId}_${tenantData.tenantId}`
                : "";

            let selectedDueItems;
            let amountToPay;

            if (payload.selectedDueItems) {
                selectedDueItems = payload.selectedDueItems;
                amountToPay = payload.amountToPay;
            } else {
                selectedDueItems = selectedDues.filter((due) => due.selected);
                amountToPay = payload.isBookingPayment ? totalDuesAmount : selectedDuesTotal;
            }

            const res = await axios.post(
                `${Config.ApiUrl}/cashfree/createorder`,
                {
                    email: userEmail,
                    mode: selectedPaymentOption,
                    dueId: selectedDueItems.map((due) => due.id).join(","),
                    ledgerReferenceId: selectedDueItems.map((due) => due.ledgerReferenceId),
                    amount: amountToPay,
                    charges: charges,
                    gstAmount: gstAmount,
                    payingFor: payload.isBookingPayment ? 3 : 2,
                    customerDetails: {
                        customer_id: customerId || "",
                        customer_name: tenantData?.tenantName || "",
                        customer_phone: tenantData?.tenantMobile?.toString() || "",
                    },
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const paymentSessionId = res?.data?.data?.payment_session_id;
            const orderId = res?.data?.data?.order_id;

            if (!paymentSessionId) {
                toast.error("Payment session not received");
                setIsCashfreeInitializing(false);
                return;
            }
            const cashfree = await load({ mode: Config.CashfreeMode });
            // const cashfree = await load({ mode: "sandbox" });
            // const cashfree = await load({ mode: "production" });

            const result = await cashfree.checkout({
                paymentSessionId,
                redirectTarget: "_modal",
            });

            if (result.error) {
                await orderStatusTransactionMutate({ orderId });
                toast.error(result.error.message);
            } else {
                toast.success("Payment completed");
                await orderStatusTransactionMutate({ orderId });
            }

        } catch (error) {
            console.error("Cashfree payment error:", error);
            toast.error(error?.response?.data?.msg || "Cashfree payment failed");
        } finally {
            setIsCashfreeInitializing(false);
        }
    };

    return {
        handleCashfreePayment,
        isCashfreeInitializing,
    };
};

// for self redirect

// import { useState } from "react";
// import axios from "axios";
// import Config from "../Config";
// import { toast } from "react-toastify";
// import { load } from "@cashfreepayments/cashfree-js";
// import { useMutation } from "react-query";
// import { Navigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// export const useCashfreePayment = (token, userEmail, selectedPaymentOption, charges, gstAmount, selectedDues, selectedDuesTotal, totalDuesAmount, tenantdata) => {
//     const [isCashfreeInitializing, setIsCashfreeInitializing] = useState(false);
//     const navigate = useNavigate();
//     console.log(Config.CashfreeMode)
//     const handleCashfreePayment = async (payload) => {
//         setIsCashfreeInitializing(true);

//         try {
//             const tenantData = tenantdata;
//             const customerId = tenantData?.propGId && tenantData?.tenantId
//                 ? `${tenantData.propGId}_${tenantData.tenantId}`
//                 : "";

//             let selectedDueItems;
//             let amountToPay;

//             if (payload.selectedDueItems) {
//                 selectedDueItems = payload.selectedDueItems;
//                 amountToPay = payload.amountToPay;
//             } else {
//                 selectedDueItems = selectedDues.filter((due) => due.selected);
//                 amountToPay = payload.isBookingPayment ? totalDuesAmount : selectedDuesTotal;
//             }

//             const res = await axios.post(
//                 `${Config.ApiUrl}/cashfree/createorder`,
//                 {
//                     email: userEmail,
//                     mode: selectedPaymentOption,
//                     dueId: selectedDueItems.map((due) => due.id).join(","),
//                     ledgerReferenceId: selectedDueItems.map((due) => due.ledgerReferenceId),
//                     amount: amountToPay,
//                     charges: charges,
//                     gstAmount: gstAmount,
//                     payingFor: payload.isBookingPayment ? 3 : 2,
//                     customerDetails: {
//                         customer_id: customerId || "",
//                         customer_name: tenantData?.tenantName || "",
//                         customer_phone: tenantData?.tenantMobile?.toString() || "",
//                     },
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             const paymentSessionId = res?.data?.data?.payment_session_id;
//             const orderId = res?.data?.data?.order_id;

//             if (!paymentSessionId) {
//                 toast.error("Payment session not received");
//                 setIsCashfreeInitializing(false);
//                 return;
//             }
//             const cashfree = await load({ mode: Config.CashfreeMode });
//             // const cashfree = await load({ mode: "sandbox" });
//             // const cashfree = await load({ mode: "production" });

//             const result = await cashfree.checkout({
//                 paymentSessionId,
//                 redirectTarget: "_self",
//             });

//             if (result.error) {
//                 toast.error(result.error.message);
//             } else {
//                 // toast.success("Payment completed");
//             }

//         } catch (error) {
//             console.error("Cashfree payment error:", error);
//             toast.error(error?.response?.data?.msg || "Cashfree payment failed");
//         } finally {
//             setIsCashfreeInitializing(false);
//         }
//     };

//     return {
//         handleCashfreePayment,
//         isCashfreeInitializing,
//     };
// };